
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/2023/partners",
      function () {
        return require("private-next-pages/sa/2023/partners.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/2023/partners"])
      });
    }
  